import { useQuery } from '@apollo/client';

import { NewsCard } from './NewsCard';

import { WIDGET_CRYPTO_NEWS } from '../../../http/apollo-queries';

import { NewsPost } from './types';
import { GridWidget } from '../types';
import { useErrorHandler } from 'react-error-boundary';

const CryptoNewsWidget = ({ width }: GridWidget) => {
  const onError = useErrorHandler();

  const columns = width === 1 ? 1 : 2;

  //Queries
  const { data: { widgetCryptoNews: { posts = [] } = {} } = {} } = useQuery<{
    widgetCryptoNews: { posts: NewsPost[]; count: number };
  }>(WIDGET_CRYPTO_NEWS, {
    fetchPolicy: 'cache-and-network',
    pollInterval: 30000,
    onError,
  });

  return (
    <div className={'overflow-y-scroll'}>
      <div className={`grid px-4 py-4 gap-4 grid-cols-${columns}`}>
        {posts.map((post, i) => (
          <NewsCard post={post} key={post.id} />
        ))}
      </div>
    </div>
  );
};

export default CryptoNewsWidget;
